/**
 * The public coin shop on nsibi.app: buy coins for any account by its
 * @username or phone number, with mobile money and no sign-in
 * (wallet/shop_views.py). This app may link to it; the store apps may not.
 * It was /coins until 2026-10-20 and that path still redirects.
 */
import { siteOrigin } from './siteOrigin';

/**
 * Where the shop is, from where THIS page is running: the site's dev
 * server under a dev server, nsibi.app in production (`siteOrigin`).
 */
export function coinShopUrl(): string {
  return `${siteOrigin()}/recharge/`;
}
